module.exports = __webpack_public_path__ + "static/media/p3.0c3f7be3.png";